import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 992 992" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="" >
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M481.227966,532.804565 
	C461.716614,525.832458 441.792969,521.759155 422.269867,516.253174 
	C408.011810,512.232056 393.814880,507.996094 380.449524,501.459625 
	C354.470856,488.754517 340.426056,461.185089 345.437286,432.697205 
	C350.292786,405.094788 366.380829,386.694031 392.471619,377.455200 
	C427.267059,365.134064 462.101593,366.446838 496.480652,379.481659 
	C520.311218,388.516998 533.750854,406.470703 539.232605,430.891754 
	C541.668640,441.744049 541.651917,441.822266 530.774536,443.513855 
	C521.242126,444.996246 511.657257,446.151917 502.145050,447.746948 
	C498.783722,448.310577 497.594849,446.918243 496.982086,444.071075 
	C491.430359,418.273865 472.518402,407.671631 449.515411,406.349609 
	C438.858551,405.737122 428.209259,406.147736 417.686584,408.325104 
	C409.652100,409.987610 402.527863,413.491913 396.679199,419.179688 
	C383.129272,432.356812 386.082092,451.708191 402.859985,461.001434 
	C412.758759,466.484344 423.835327,468.488312 434.515503,471.523926 
	C457.705475,478.115173 481.118896,483.948395 503.858948,492.032806 
	C518.204285,497.132751 531.507263,504.159424 540.018799,517.376770 
	C555.944092,542.106689 554.789185,567.536743 540.992065,592.561401 
	C529.264648,613.832153 509.897186,625.724854 487.048218,631.591919 
	C455.937439,639.580383 424.763397,639.100647 394.110260,628.751831 
	C370.710724,620.851868 355.225677,604.529236 345.529755,582.187744 
	C341.676086,573.308167 339.065979,564.140137 337.518799,554.091736 
	C351.487457,551.749512 365.045288,549.459595 378.610474,547.213989 
	C381.747253,546.694763 382.046295,549.005859 382.432800,551.228027 
	C384.445007,562.796082 388.927277,573.191284 396.890015,581.984497 
	C406.863190,592.997864 419.948669,597.919434 434.082275,599.341370 
	C448.818970,600.823914 463.744049,600.878906 477.965546,595.283447 
	C489.306244,590.821350 497.938385,583.400818 502.722931,571.992981 
	C508.917206,557.223816 503.094818,542.426147 488.528625,535.758240 
	C486.261597,534.720520 483.899109,533.891296 481.227966,532.804565 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M596.026001,580.927979 
	C586.188110,600.705933 576.514282,620.147095 566.934570,639.399231 
	C564.395935,639.205200 564.178772,637.531616 563.536804,636.238037 
	C558.432434,625.952454 553.448547,615.604248 548.157349,605.415649 
	C546.198547,601.643738 546.107178,598.653625 548.426147,594.833862 
	C556.949890,580.793945 560.958557,565.584839 558.853149,549.046631 
	C558.718994,547.992859 558.199341,546.738342 559.812439,545.736267 
	C562.719971,548.881409 563.373718,553.370239 566.517639,557.444458 
	C604.807556,488.580078 642.851624,420.157806 681.197815,351.192169 
	C687.830200,356.545593 693.116272,362.234070 698.336853,367.961029 
	C700.154968,369.955536 698.557861,371.996918 697.600281,373.937653 
	C681.912781,405.733765 666.197266,437.516266 650.582275,469.348053 
	C632.403809,506.405701 614.316833,543.508240 596.026001,580.927979 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M678.655945,319.903412 
	C688.938477,300.530426 714.210754,298.099396 728.064331,308.531525 
	C738.965088,316.740112 743.379517,327.753784 741.284790,340.898041 
	C739.172852,354.150513 731.161377,363.043579 718.319153,367.312134 
	C716.700195,367.850281 714.508362,368.970917 713.591248,366.452515 
	C712.621216,363.788757 715.064758,363.548645 716.726685,363.041870 
	C730.867737,358.730133 738.282104,344.917969 737.213928,333.296112 
	C735.873535,318.713257 725.299500,307.885254 710.505066,306.677277 
	C694.669495,305.384308 680.087646,317.497253 679.482971,335.572784 
	C679.455261,336.401398 679.640625,337.238068 679.602173,338.065216 
	C679.534363,339.523560 679.781494,341.415222 677.765869,341.617065 
	C675.449524,341.849091 675.217896,339.868073 675.095520,338.199341 
	C674.635254,331.922607 675.862061,325.947906 678.655945,319.903412 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M464.670441,661.083618 
	C464.708130,652.995544 464.708130,652.991394 472.462219,653.003296 
	C474.128143,653.005798 475.796661,652.998901 477.459503,653.083862 
	C488.356964,653.640869 491.575317,658.995667 486.970123,669.092102 
	C487.951141,670.523621 489.243896,671.897278 489.946106,673.525574 
	C492.677643,679.859253 488.486908,686.635132 481.584778,687.270325 
	C464.662323,688.827942 464.663177,688.827881 464.676086,672.066711 
	C464.678772,668.567810 464.672455,665.068909 464.670441,661.083618 
M482.579376,673.696411 
	C480.255829,671.974792 477.548920,672.476318 474.933197,672.306580 
	C471.497040,672.083557 470.218903,673.568970 470.295074,676.969788 
	C470.399841,681.648682 474.062469,683.779785 479.826324,682.250793 
	C484.246979,681.078003 485.307892,678.502869 482.579376,673.696411 
M481.750122,665.379333 
	C483.776642,660.141174 481.249817,657.922058 474.210388,658.308411 
	C471.069061,658.480774 470.377319,660.025391 470.297363,662.742676 
	C470.209717,665.720947 471.408447,667.075928 474.371216,666.863403 
	C476.651123,666.699890 479.026215,667.200989 481.750122,665.379333 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M590.285034,663.555298 
	C590.558899,656.965454 593.148438,653.892761 598.897156,652.856445 
	C605.785645,651.614746 612.480835,654.178467 614.519043,658.916138 
	C615.244629,660.602478 616.057739,662.599487 613.906006,663.751892 
	C612.057556,664.741943 610.453186,664.089172 609.389404,662.068542 
	C607.053528,657.631714 603.142639,657.625427 599.023254,658.757629 
	C597.513733,659.172607 596.463806,660.321045 596.366272,662.033813 
	C596.264465,663.823120 597.368286,664.900085 598.862122,665.363281 
	C601.875671,666.297913 604.963684,666.989319 608.008179,667.827637 
	C613.838623,669.432983 616.461548,672.692139 616.307434,678.075073 
	C616.157166,683.323303 613.168823,686.622803 607.415710,687.892944 
	C599.830566,689.567505 592.173096,686.654541 589.721130,681.060913 
	C588.947815,679.296814 587.682007,677.143616 590.245911,675.863586 
	C592.378418,674.798889 593.791077,675.901367 595.062195,677.944519 
	C598.088989,682.809692 603.489258,684.141052 607.927734,681.461853 
	C611.340515,679.401978 611.416016,676.559753 607.982605,674.597046 
	C605.507202,673.181946 602.648621,672.813904 599.929382,672.051697 
	C595.567322,670.828918 591.092163,669.535583 590.285034,663.555298 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M392.508911,681.653687 
	C395.711456,677.851257 395.367645,675.556335 391.279449,673.919556 
	C388.061340,672.631165 384.569763,672.044312 381.277985,670.916992 
	C377.090820,669.483093 374.548859,666.633484 374.813904,661.965271 
	C375.084442,657.200195 377.864410,654.368469 382.283112,653.083923 
	C389.311584,651.040527 397.208130,653.779602 399.248199,658.937256 
	C399.904907,660.597595 400.970520,662.581970 398.723785,663.770691 
	C396.623322,664.882141 394.865570,664.066162 393.828400,661.888977 
	C392.916138,659.973938 391.565430,658.554138 389.352509,658.358826 
	C386.015350,658.064270 381.979767,657.429443 381.073120,661.703369 
	C380.227966,665.687500 384.376556,665.494385 386.838226,666.371521 
	C389.649445,667.373291 392.677460,667.833435 395.390656,669.029480 
	C401.295929,671.632751 402.998199,678.512817 399.074402,683.610657 
	C395.620453,688.098083 390.636047,688.639526 385.516693,688.089050 
	C380.703674,687.571533 376.372040,685.949097 374.428467,680.906067 
	C373.748413,679.141541 372.335022,677.052429 375.045105,675.784302 
	C377.300507,674.729004 378.539612,675.882996 379.717987,677.988892 
	C382.342102,682.678406 385.684387,683.559692 392.508911,681.653687 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M708.089722,347.211609 
	C700.695007,345.960602 696.964905,342.062256 696.709045,335.742218 
	C696.490112,330.334015 699.506836,325.964661 704.577209,324.346191 
	C710.161316,322.563721 715.795227,324.773254 718.785095,329.725739 
	C722.868042,336.488586 717.928467,347.475403 708.089722,347.211609 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M439.975861,661.155762 
	C440.551819,657.931274 438.339020,653.205383 443.289825,653.353882 
	C447.693634,653.485962 446.100830,657.951782 446.084015,660.613770 
	C446.045197,666.749878 446.851990,672.930969 445.391724,679.027283 
	C443.900940,685.250793 439.761902,688.251160 432.458221,688.260986 
	C424.614136,688.271423 420.196899,685.489990 419.169098,678.936096 
	C417.980042,671.353821 418.809113,663.645447 418.767090,655.992065 
	C418.757263,654.204102 419.714417,653.182068 421.549072,653.212036 
	C423.720917,653.247437 424.320374,654.631042 424.316345,656.547546 
	C424.303711,662.544373 424.273987,668.541870 424.348175,674.537903 
	C424.402100,678.898743 426.343842,681.869873 430.906342,682.587341 
	C435.688171,683.339233 439.238434,680.934448 439.670502,676.105347 
	C440.099518,671.310242 439.903015,666.459229 439.975861,661.155762 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M565.445679,655.607544 
	C569.442993,665.674927 573.286560,675.383301 577.085144,685.109192 
	C577.237549,685.499329 576.964600,686.055481 576.871521,686.651917 
	C573.130371,688.491211 570.844910,687.259155 570.004700,683.344299 
	C569.122864,679.235413 567.191284,677.224243 562.533020,677.229309 
	C557.591797,677.234680 554.142761,678.183838 552.998291,683.537964 
	C552.226624,687.148071 550.083130,688.588013 546.514465,686.853088 
	C545.556335,685.422180 546.395020,684.197205 546.850098,683.015259 
	C550.247314,674.191589 553.662231,665.374268 557.148071,656.585266 
	C558.962769,652.009888 561.332825,651.662964 565.445679,655.607544 
M560.376343,663.686401 
	C559.442627,666.429871 558.508911,669.173401 557.463989,672.243530 
	C560.316895,672.564636 562.644836,672.788391 565.438110,671.980835 
	C564.515198,669.398682 563.788086,667.079712 562.838989,664.855469 
	C562.480591,664.015442 562.875427,661.677124 560.376343,663.686401 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M726.133423,338.198334 
	C727.386353,327.354248 719.472961,317.937286 709.040955,317.367065 
	C699.698303,316.856384 690.684631,325.401276 690.322449,335.094849 
	C690.253052,336.953613 691.152832,339.741791 688.069031,339.588379 
	C685.282959,339.449738 685.853821,336.723419 685.880981,334.820038 
	C686.040100,323.681580 694.437622,314.812592 706.219482,313.259277 
	C716.500671,311.903839 727.227295,319.019897 729.990662,329.029144 
	C733.096436,340.278778 728.022461,351.720886 717.951721,356.153748 
	C717.193176,356.487579 716.421997,356.869659 715.618713,357.007568 
	C714.191101,357.252625 712.443542,357.847107 711.794678,355.885742 
	C711.158508,353.963135 712.639771,353.337250 714.143066,352.774841 
	C720.772522,350.294525 724.645386,345.469666 726.133423,338.198334 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M533.371277,662.258179 
	C530.590271,669.443298 527.939941,676.265320 525.301941,683.092041 
	C524.475525,685.230774 524.119568,687.631042 520.866150,687.575134 
	C517.933289,687.524658 516.870117,685.763733 515.992432,683.447205 
	C512.752136,674.894409 509.432800,666.371460 506.206787,657.813354 
	C505.619110,656.254333 503.991272,654.270325 506.744781,653.225586 
	C509.156250,652.310669 510.977600,653.347595 511.860138,655.791260 
	C514.288208,662.514282 516.685791,669.248474 519.097595,675.977417 
	C519.484253,677.056152 519.882568,678.130737 520.552063,679.964844 
	C523.556580,672.010498 526.279358,664.743408 529.059692,657.498535 
	C529.528137,656.277832 530.059143,654.991272 530.896667,654.026367 
	C531.818787,652.963989 533.270020,652.808838 534.597168,653.363403 
	C536.316833,654.082092 535.870850,655.460876 535.415527,656.749756 
	C534.806030,658.474915 534.145447,660.181946 533.371277,662.258179 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M481.040619,792.312805 
	C477.726471,792.215210 474.901520,792.174377 472.082336,792.025391 
	C468.971863,791.861023 468.380402,790.003784 468.703064,787.222839 
	C469.047882,784.251221 470.650360,783.958435 473.200775,784.146362 
	C487.302673,785.185608 501.428741,785.055725 515.527161,784.224365 
	C518.971069,784.021362 520.404114,784.852234 520.829529,788.195679 
	C521.297363,791.872192 518.662964,792.000000 516.437256,792.038025 
	C504.804077,792.236755 493.167664,792.246460 481.040619,792.312805 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M298.702026,710.746033 
	C300.477264,709.969849 301.481232,710.753052 302.545105,711.651428 
	C307.230713,715.608337 311.908051,719.578430 316.696045,723.409119 
	C319.028351,725.275146 319.723999,726.990723 317.784149,729.668945 
	C315.622101,732.654053 313.714142,731.634766 311.589355,729.858154 
	C307.265656,726.242981 303.037201,722.502869 298.570679,719.073120 
	C294.902588,716.256470 294.714539,713.721680 298.702026,710.746033 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M329.323608,742.723633 
	C326.624359,741.147034 324.275299,739.949646 326.539246,736.434631 
	C328.788422,732.942566 330.873138,734.076599 333.501709,735.837646 
	C338.184357,738.974792 342.972748,741.965637 347.828949,744.827515 
	C350.408081,746.347412 351.497589,747.822266 349.690979,750.766296 
	C347.845337,753.774048 345.848114,753.250305 343.475616,751.730103 
	C338.868011,748.777710 334.242706,745.852966 329.323608,742.723633 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M312.089142,316.143127 
	C307.465240,320.205414 303.106384,324.039246 298.780121,327.909454 
	C296.880890,329.608490 295.137604,330.718140 292.858551,328.287781 
	C290.659698,325.942932 290.804718,324.064087 293.174042,322.008362 
	C297.807098,317.988586 302.335938,313.848877 306.960785,309.819427 
	C308.615631,308.377625 310.325073,306.895538 312.411530,309.452118 
	C314.250397,311.705261 315.793213,313.787506 312.089142,316.143127 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M281.078949,346.066772 
	C278.204559,349.544006 275.450500,352.666901 272.897308,355.946228 
	C271.042206,358.328918 269.269104,358.436188 267.025574,356.537262 
	C265.050842,354.865814 264.399384,353.241028 266.306305,351.072540 
	C270.591278,346.199860 274.838837,341.293640 279.048431,336.355713 
	C280.870636,334.218262 282.438843,333.642944 284.793976,335.918335 
	C287.231171,338.273041 286.991516,340.043091 284.688110,342.130066 
	C283.459930,343.242889 282.413696,344.556488 281.078949,346.066772 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M738.051025,665.007751 
	C735.715820,668.460571 733.609009,671.633423 731.492615,674.799866 
	C729.952698,677.103821 728.230286,677.760071 725.693787,675.972656 
	C723.232910,674.238525 723.042786,672.615906 724.744873,670.207520 
	C728.374634,665.071655 731.864807,659.834473 735.311279,654.572754 
	C736.951233,652.069153 738.712891,651.964050 741.130310,653.486267 
	C743.608826,655.046875 743.457031,656.811279 742.089355,658.911499 
	C740.824646,660.853699 739.547119,662.787537 738.051025,665.007751 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M260.116272,662.906250 
	C261.846497,665.366760 263.252655,667.631470 264.930084,669.673340 
	C266.969208,672.155396 266.598633,673.893921 264.067627,675.817139 
	C261.389008,677.852478 259.748962,676.578430 258.333588,674.494446 
	C254.802292,669.295044 251.421936,663.993347 247.923721,658.771179 
	C246.275925,656.311340 246.762787,654.605042 249.276291,653.060547 
	C251.889481,651.454773 253.403458,652.065491 254.812378,654.687927 
	C256.294312,657.446411 258.194824,659.979919 260.116272,662.906250 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M271.161682,690.738281 
	C268.889069,688.376221 268.179626,686.518188 271.033356,684.302368 
	C273.772461,682.175659 275.418060,683.215637 277.300171,685.391541 
	C281.220917,689.924500 285.184174,694.430298 289.332245,698.753174 
	C291.541351,701.055298 290.927094,702.712646 289.007416,704.655518 
	C286.957367,706.730469 285.190155,706.211731 283.478424,704.336182 
	C279.437714,699.908752 275.425812,695.455017 271.161682,690.738281 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M673.557495,723.421021 
	C678.141724,719.546936 682.489136,715.928406 686.753357,712.214233 
	C688.787170,710.442871 690.431091,709.679138 692.530334,712.322144 
	C694.349548,714.612488 694.510071,716.322327 692.201843,718.225952 
	C687.455139,722.140503 682.764954,726.123413 678.039062,730.063293 
	C676.139160,731.647034 674.427551,732.898804 672.221802,730.122253 
	C669.988220,727.310547 670.403076,725.385437 673.557495,723.421021 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M658.350830,291.561920 
	C661.642883,293.840515 664.625427,295.929962 667.591919,298.041901 
	C669.617920,299.484222 670.407471,301.024689 668.693542,303.431213 
	C666.971558,305.849091 665.197937,306.168762 662.840088,304.589386 
	C657.616577,301.090363 652.407349,297.568573 647.136414,294.142151 
	C644.652405,292.527405 644.513000,290.860138 646.031494,288.352631 
	C647.743713,285.525055 649.521973,285.942108 651.746704,287.409943 
	C653.815613,288.775024 655.936462,290.061340 658.350830,291.561920 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M376.255402,759.660278 
	C378.278320,760.538696 379.954376,761.268188 381.647766,761.954834 
	C383.932892,762.881470 385.310516,764.132996 384.114227,766.895386 
	C383.051117,769.350342 381.916595,770.716553 378.870636,769.463623 
	C372.864777,766.993225 366.979706,764.298462 361.179443,761.383423 
	C358.519806,760.046814 357.926758,758.366699 359.286560,755.784546 
	C360.711334,753.078918 362.675751,753.075745 365.119385,754.305420 
	C368.685394,756.099915 372.314240,757.769470 376.255402,759.660278 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M762.159668,415.822693 
	C763.819336,418.971283 764.378784,421.329895 760.483643,422.895416 
	C756.529602,424.484650 756.058838,421.702332 754.969849,419.249023 
	C752.676208,414.081573 750.350220,408.923920 747.851379,403.853912 
	C746.595154,401.304962 746.820129,399.605530 749.389038,398.061035 
	C752.285583,396.319550 753.730591,397.746582 754.854553,400.117737 
	C757.274658,405.223328 759.618408,410.365204 762.159668,415.822693 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M623.050049,271.887177 
	C627.105225,273.908173 630.831116,275.756744 634.571045,277.576630 
	C637.243347,278.876984 637.630737,280.646667 636.182129,283.244843 
	C634.822327,285.683868 633.215271,286.022430 630.850891,284.835724 
	C625.201538,282.000153 619.549377,279.162872 613.812622,276.511810 
	C610.859863,275.147278 611.101074,273.288269 612.147766,270.822327 
	C613.288269,268.135376 614.995789,267.912354 617.331177,269.100525 
	C619.110413,270.005737 620.926880,270.837830 623.050049,271.887177 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M757.673218,630.561279 
	C755.544189,634.722168 753.526306,638.517700 751.643738,642.379211 
	C750.425293,644.878540 748.812683,645.283813 746.450256,643.939270 
	C744.366577,642.753174 743.021362,641.643677 744.439880,638.893188 
	C747.467285,633.023254 750.250977,627.026306 753.069458,621.050659 
	C754.356079,618.322632 756.265869,618.767395 758.442017,619.701294 
	C760.618164,620.635193 761.630371,621.913025 760.432800,624.320557 
	C759.476807,626.242371 758.698792,628.252808 757.673218,630.561279 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M715.250488,683.201172 
	C721.741882,685.650879 722.176453,687.012390 717.998474,691.762085 
	C714.175354,696.108154 710.155090,700.280212 706.258972,704.562927 
	C704.515015,706.479980 702.974426,706.896912 700.865112,704.845520 
	C698.801758,702.838745 698.382141,701.199158 700.466553,698.984131 
	C705.335083,693.810547 710.099976,688.539368 715.250488,683.201172 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M242.187866,632.803833 
	C243.329300,634.879700 244.253448,636.651123 245.264450,638.371460 
	C246.722977,640.853271 245.658051,642.357544 243.481094,643.644958 
	C241.067505,645.072266 239.304321,644.410889 238.152390,642.081055 
	C235.130753,635.969910 232.157623,629.833496 229.267197,623.659363 
	C228.092072,621.149353 229.862534,620.082397 231.800995,619.133423 
	C233.963898,618.074524 235.639160,618.263245 236.702377,620.641541 
	C238.466888,624.588562 240.239944,628.531738 242.187866,632.803833 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M354.623901,284.151245 
	C352.035736,280.586273 353.072327,278.564911 356.571381,276.972473 
	C361.846069,274.571930 367.002960,271.909546 372.180450,269.300049 
	C374.709473,268.025391 376.706604,267.651550 378.179230,270.905273 
	C379.558441,273.952515 378.573853,275.374237 375.762451,276.641449 
	C370.179657,279.157776 364.705261,281.919067 359.229767,284.666290 
	C357.643768,285.462036 356.222961,286.183350 354.623901,284.151245 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M649.684204,749.803101 
	C647.942505,750.842163 646.522156,751.702759 645.073669,752.513000 
	C642.828613,753.768860 641.408325,752.906555 640.220215,750.810974 
	C639.100586,748.836365 638.604553,747.259277 640.953003,745.776611 
	C646.707825,742.143250 652.413574,738.430542 658.095825,734.684204 
	C660.483459,733.110046 661.598389,734.512634 662.921692,736.269775 
	C664.599609,738.497803 664.313782,740.255798 662.102844,741.726624 
	C658.093811,744.393250 654.032410,746.981323 649.684204,749.803101 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M237.362473,397.144836 
	C243.700790,398.667847 243.967545,399.271973 241.460190,404.739044 
	C239.108475,409.866730 236.799683,415.014862 234.541733,420.184448 
	C233.404831,422.787415 231.795303,423.625000 229.022842,422.478271 
	C225.933334,421.200439 226.285797,419.267181 227.427933,416.867889 
	C230.551880,410.305450 232.700790,403.267700 237.362473,397.144836 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M605.591675,763.605957 
	C612.279968,760.242065 618.751770,757.213562 625.181152,754.097534 
	C627.687805,752.882629 629.140320,753.617981 630.368225,756.030029 
	C631.580627,758.411560 631.509949,760.065002 628.888123,761.260498 
	C623.285706,763.815125 617.784241,766.606445 612.103516,768.969055 
	C607.013916,771.085754 605.817505,770.046936 605.591675,763.605957 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M413.976807,257.134033 
	C415.107208,260.197083 414.929352,262.224670 411.601440,263.241791 
	C405.565369,265.086639 399.584839,267.125366 393.634644,269.234100 
	C390.764679,270.251221 389.399109,269.348999 388.446899,266.544861 
	C387.490356,263.727783 388.641449,262.501923 391.047882,261.706390 
	C397.204590,259.671112 403.362488,257.638977 409.507416,255.568588 
	C411.266327,254.975967 412.778748,254.984711 413.976807,257.134033 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M329.892700,292.835114 
	C332.977234,290.846405 335.814575,289.132355 338.523529,287.235016 
	C340.935516,285.545624 342.647125,285.822937 344.195068,288.413971 
	C345.689178,290.914917 345.327545,292.614258 342.820160,294.182800 
	C337.768860,297.342682 332.812286,300.655396 327.849060,303.953949 
	C325.666992,305.404114 323.682861,305.989380 321.858734,303.427948 
	C319.899445,300.676727 321.024994,298.918762 323.519836,297.346344 
	C325.616882,296.024628 327.571808,294.477386 329.892700,292.835114 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M243.933701,383.888062 
	C247.714279,377.840485 251.339081,372.110748 254.949707,366.372070 
	C256.312225,364.206451 257.804504,363.479706 260.224854,365.145966 
	C262.569885,366.760315 263.263702,368.193573 261.511780,370.790741 
	C257.998901,375.998535 254.755814,381.388306 251.400452,386.702393 
	C250.499725,388.128906 249.551193,389.783112 247.539749,388.857208 
	C245.615219,387.971344 242.665146,387.645569 243.933701,383.888062 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M584.226562,256.689880 
	C589.481079,258.449005 594.324219,260.203949 599.230042,261.761566 
	C602.124207,262.680450 602.703369,264.094360 601.578491,266.970947 
	C600.435303,269.894287 598.880188,270.348297 596.210144,269.255066 
	C590.978455,267.112976 585.630615,265.314667 580.161438,263.836975 
	C577.638428,263.155273 574.995667,262.409363 576.203308,258.411621 
	C577.409729,254.417801 579.785889,255.348618 582.410400,256.167297 
	C582.886414,256.315796 583.364380,256.457794 584.226562,256.689880 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M394.339142,771.447510 
	C395.700500,768.126465 397.958771,768.443665 400.339020,769.174805 
	C406.055908,770.930786 411.757416,772.738525 417.491730,774.435486 
	C419.657745,775.076538 421.164764,775.873779 420.393738,778.592896 
	C419.691101,781.070740 418.773468,783.182861 415.672852,782.250244 
	C408.992584,780.240906 402.338196,778.140747 395.711151,775.962280 
	C393.706268,775.303162 393.630737,773.603455 394.339142,771.447510 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M546.518555,780.428223 
	C549.217896,779.861511 551.498779,779.410522 553.768494,778.909363 
	C556.591858,778.285950 558.061157,779.291931 558.709473,782.218567 
	C559.370667,785.203613 557.944824,786.167114 555.483032,786.612000 
	C549.100586,787.765442 542.724426,788.955566 536.333313,790.058716 
	C533.643127,790.523071 532.371399,789.140686 531.970215,786.538879 
	C531.555847,783.851440 532.584656,782.389526 535.234375,782.018616 
	C538.853516,781.511780 542.474731,781.020020 546.518555,780.428223 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M770.268921,583.625854 
	C773.234497,584.095032 773.937500,585.759827 773.249329,588.028992 
	C771.326477,594.368896 769.248413,600.661682 767.326294,607.001770 
	C766.440735,609.922668 764.470886,609.816284 762.215881,609.093079 
	C759.736572,608.297974 758.924500,606.964905 759.908997,604.203064 
	C761.965759,598.433105 763.676758,592.535706 765.395630,586.651428 
	C766.095520,584.255310 767.059631,582.642334 770.268921,583.625854 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M595.211487,775.229858 
	C588.314880,777.683350 581.715515,779.944946 575.043274,781.965698 
	C572.906738,782.612793 570.563599,783.337952 569.599915,779.758545 
	C568.726074,776.512512 569.812012,775.203491 572.737793,774.369995 
	C578.170776,772.822144 583.546570,771.074280 588.952332,769.430115 
	C594.123596,767.857178 595.580566,769.096924 595.211487,775.229858 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M772.781860,550.081848 
	C772.954651,546.317383 774.793640,545.388794 777.835632,545.998657 
	C780.688782,546.570557 780.817017,548.361389 780.561890,550.838684 
	C779.932251,556.951965 778.875305,562.977844 777.634277,568.986816 
	C777.120483,571.474304 776.626465,573.531128 773.223633,572.731018 
	C769.987000,571.969910 769.499573,570.036987 770.013855,567.172607 
	C771.007935,561.636353 771.849609,556.072693 772.781860,550.081848 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M550.814880,256.351868 
	C547.786621,255.881393 545.190308,255.410507 542.580139,255.036194 
	C539.847290,254.644287 538.427368,253.370300 538.828430,250.387344 
	C539.235291,247.361252 540.884094,246.538666 543.681824,247.104782 
	C549.994324,248.382004 556.314880,249.620926 562.643250,250.816635 
	C565.396179,251.336777 566.060486,252.802170 565.391541,255.449982 
	C564.754944,257.969818 563.717896,259.256439 560.904480,258.530121 
	C557.712158,257.705963 554.464417,257.096649 550.814880,256.351868 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M506.659790,243.569977 
	C512.724487,243.737869 518.341248,243.786484 523.945374,244.571472 
	C526.648254,244.950073 527.642090,245.858185 527.516541,248.644714 
	C527.377625,251.727936 526.051941,252.648346 523.145142,252.406662 
	C517.377991,251.927155 511.598572,251.530624 505.816223,251.324417 
	C502.841461,251.218338 500.617828,250.913818 500.703369,247.070450 
	C500.797089,242.858734 503.505859,243.339249 506.659790,243.569977 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M449.820129,789.348511 
	C444.327423,788.338013 439.274109,787.323425 434.198486,786.436829 
	C431.845245,786.025818 430.529846,785.061584 431.050598,782.434753 
	C431.585449,779.736816 432.860565,778.291565 435.870514,778.851624 
	C441.426788,779.885498 446.984497,780.965576 452.585480,781.684875 
	C456.000061,782.123352 457.784729,783.323730 457.325806,787.053833 
	C456.825287,791.122253 454.155365,790.002991 451.729950,789.633850 
	C451.236176,789.558655 450.743561,789.475952 449.820129,789.348511 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M216.899994,487.677124 
	C216.619659,489.764008 216.362488,491.410126 216.266602,493.065552 
	C216.115067,495.681458 214.612335,496.398834 212.249786,496.300720 
	C210.103638,496.211639 208.532700,495.473022 208.778275,493.105621 
	C209.514328,486.009857 210.290771,478.914185 211.283691,471.851135 
	C211.670074,469.102631 214.014267,469.396484 216.044937,469.718811 
	C218.122223,470.048523 219.381363,471.054413 219.011414,473.439484 
	C218.298828,478.033508 217.663116,482.639496 216.899994,487.677124 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M431.161102,249.868469 
	C436.663940,248.945236 441.749664,248.137299 446.811646,247.200897 
	C449.327972,246.735413 450.971954,247.045715 451.360718,250.094131 
	C451.718658,252.901154 451.086426,254.497955 448.042328,254.979935 
	C442.468231,255.862503 436.929657,256.969543 431.376862,257.986298 
	C428.726044,258.471680 426.040771,259.284485 425.013489,255.445114 
	C423.976379,251.568848 426.522186,250.900482 429.279297,250.289368 
	C429.766815,250.181320 430.249359,250.050873 431.161102,249.868469 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M222.299622,432.991913 
	C228.738907,433.422028 229.113098,434.020325 227.498062,439.350952 
	C225.910736,444.590240 224.490051,449.881134 223.065353,455.168030 
	C222.407288,457.610016 221.674744,459.585693 218.391998,458.845154 
	C215.142105,458.112030 214.480286,456.410400 215.430786,453.410370 
	C217.573380,446.647858 218.373199,439.457428 222.299622,432.991913 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M224.250641,585.912842 
	C226.168335,591.974731 227.963211,597.656433 229.868271,603.300903 
	C230.710129,605.795227 230.848877,607.779724 227.790726,608.830322 
	C224.776367,609.865845 223.110992,608.910400 222.231628,605.890686 
	C220.519211,600.010193 218.572250,594.196960 216.917587,588.301086 
	C216.372818,586.360107 216.443497,584.363647 219.046692,583.482300 
	C221.457535,582.666077 223.279129,582.776245 224.250641,585.912842 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M781.169800,489.178772 
	C781.239502,490.959717 781.287598,492.288177 781.272461,493.615936 
	C781.238037,496.621063 778.860352,496.240753 776.977478,496.533569 
	C774.813538,496.870148 774.024719,495.682617 773.778442,493.726105 
	C773.074402,488.134155 772.374573,482.539825 771.531738,476.967804 
	C770.585083,470.709747 770.879395,470.278839 777.598694,469.912109 
	C780.162964,475.875061 779.906372,482.449005 781.169800,489.178772 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M763.348755,441.528870 
	C762.807373,440.062103 762.375427,438.985901 762.028503,437.882965 
	C761.192322,435.224762 762.478699,433.858459 764.911865,433.130615 
	C767.277039,432.423035 768.652405,433.155487 769.363831,435.586182 
	C771.127441,441.611572 773.045288,447.591583 774.854553,453.603882 
	C775.624146,456.161255 775.185730,458.088623 772.188477,458.925262 
	C769.190002,459.762177 768.037964,458.546844 767.369446,455.739624 
	C766.260986,451.085388 764.805847,446.513763 763.348755,441.528870 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M211.559448,565.166748 
	C210.799683,559.647156 210.178040,554.528992 209.370148,549.440491 
	C209.054794,547.454224 209.341095,546.066467 211.556915,545.866577 
	C213.678680,545.675110 216.210709,545.145264 216.749924,548.198853 
	C217.962616,555.066589 219.057480,561.957092 220.065491,568.858032 
	C220.413147,571.238220 218.666031,571.974915 216.678009,572.292175 
	C214.679672,572.611206 212.993790,572.491638 212.583054,569.963257 
	C212.343582,568.489075 211.948318,567.040222 211.559448,565.166748 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M486.739716,243.733734 
	C490.197021,244.779984 489.350494,247.252213 489.085907,249.235825 
	C488.789978,251.454605 486.727783,251.187958 485.106842,251.291397 
	C479.140137,251.672119 473.167542,251.968826 467.205292,252.407501 
	C464.740051,252.588852 462.932983,252.292740 462.756226,249.242737 
	C462.599365,246.536469 463.179993,244.984970 466.350952,244.545151 
	C472.982391,243.625351 479.619019,243.697723 486.739716,243.733734 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M780.688049,534.434021 
	C775.835083,535.670776 774.372437,533.838135 774.643372,529.377808 
	C774.984619,523.759521 774.823181,518.106262 774.756042,512.469543 
	C774.723511,509.736694 775.524414,508.009064 778.577393,507.841064 
	C781.867432,507.660034 782.402283,509.577209 782.371521,512.243774 
	C782.302673,518.212952 782.353638,524.183472 782.310730,530.153137 
	C782.300232,531.614319 782.493774,533.191223 780.688049,534.434021 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M207.778992,510.305359 
	C208.856247,506.947662 211.245087,507.542450 213.258331,507.994904 
	C215.295319,508.452698 215.215683,510.432129 215.224976,512.094055 
	C215.259323,518.234985 215.225082,524.376404 215.276764,530.517090 
	C215.296768,532.893005 214.493607,534.248596 211.863464,534.314575 
	C209.237885,534.380371 207.739517,533.522217 207.747101,530.687195 
	C207.764862,524.049011 207.733383,517.410645 207.778992,510.305359 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M736.590210,383.386292 
	C734.599182,380.308014 732.841919,377.503876 730.949219,374.794403 
	C729.213379,372.309509 729.259460,370.491760 732.031677,368.629211 
	C734.713806,366.827179 736.163696,367.673401 737.608582,370.037598 
	C740.108154,374.127258 742.729736,378.142242 745.255615,382.216095 
	C746.643921,384.455292 747.606750,386.473663 744.466919,388.425934 
	C741.183655,390.467560 739.673096,388.930908 738.286865,386.259460 
	C737.830627,385.380371 737.275024,384.552856 736.590210,383.386292 
z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
